import { StoreProduct } from '@medusajs/types'
import { quicksand } from '@/utilities/fontImport'
import Image from 'next/image'
import Link from 'next/link'
import { Button } from '../../../ui/Button'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { getPreselectedVariant } from '@onclicks/sharedmedusa/utils/get-preselected-variant'
import { optionsAsKeymap } from '@onclicks/sharedmedusa/utils/options-as-keymap'
import { getProductUrl } from '@onclicks/sharedmedusa/utils/get-product-url'
import CardPrice from './CardPrice'

export default function Card({ product }: { product: StoreProduct }) {
  const variant = product ? getPreselectedVariant(product) : null
  // On inclut les options de la variante déjà présélectionnée (celle dont le prix est affiché
  // sur la carte) pour que la fiche produit ouvre bien sur cette même variante.
  const href = getProductUrl(product, optionsAsKeymap(variant?.options))

  return (
    <Link href={href} className="group block h-full w-full rounded-3xl">
      <figure className="relative flex flex-col h-full w-full rounded-3xl bg-white shadow-lg/30 transition-all duration-400 group-hover:ring-5 group-hover:ring-primary">
        {/* `fill` sort l'image du flux : sans hauteur imposée (mobile), le conteneur s'effondrerait. */}
        <div className="relative aspect-square lg:aspect-auto lg:h-[40vh] w-full">
          {product && product.thumbnail && (
            <Image
              src={product.thumbnail}
              alt={product.title}
              fill
              sizes="(min-width: 48rem) 33vw, 100vw"
              className="object-contain p-3 transition-all duration-400 group-hover:p-0 rounded-t-3xl h-full w-full"
            />
          )}
        </div>
        {product && (
          <div className="flex flex-1 flex-col px-4">
            <h1 className={`font-bold uppercase py-3 ${quicksand.className}`}>{product.title}</h1>
            <CardPrice product={product} variant={variant ?? undefined} />
          </div>
        )}
        {/* Faux bouton : le lien est porté par la carte entière, pas besoin d'un second <a> imbriqué */}
        <Button asChild className="w-[90%] mx-auto mt-auto mb-2 bg-primary group-hover:bg-pink">
          <span>
            <span>Voir</span>
            <InformationCircleIcon className="shrink-0 w-4 mt-0.5 ml-2" />
          </span>
        </Button>
      </figure>
    </Link>
  )
}
